// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1tePV","menu":"Navbar_menu__2OArE"};